<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">403</h1>
            <h4 class="pt-3">Oops! Das ist nicht erlaubt!</h4>
            <p class="text-muted">Bitte verwenden Sie die Menüs in der Übersichtstabelle um zur jeweiligen Detail-Seite zu navigieren.</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page403'
}
</script>
